import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';

const getStyles = (_, { palette }) => ({
  previewFlowLayout: {
    height: '100%',
    width: '100%',
    '& .react-block-ui-none, .react-block-ui': {
      height: '100%',
      width: '100%',
    },
    '& .error': {
      color: '#A80000',
    },
    background: palette.neutralLighterAlt,
  },
  stepContentAndFooter: {
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  stepContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1080px',
    width: '100%',
    padding: '24px',
    margin: '0px auto',
  },
  stepListContainer: {
    maxWidth: '610px',
    marginBottom: '24px',
  },
  footerContainer: {
    borderTop: `1px solid ${palette.neutralQuaternaryAlt}`,
    padding: '16px 32px',
  },
});

export const PreviewFlowTemplate = ({ items }) => {
  const {
    Blocker = React.Fragment,
    LoadingShimmer,
    StepList,
    StepContainer,
    Footer,
  } = items;
  const classes = useDefaultStyles(getStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  return (
    <div className={classNames('preview-flow-layout', classes.previewFlowLayout)}>
      <Blocker>
        <div className={classNames('step-content-and-footer', classes.stepContentAndFooter, classes[`stepContentAndFooter-${displayMode}`])}>
          <div className={classNames('scroll-container', classes.scrollContainer, classes[`scrollContainer-${displayMode}`])}>
            <div className={classNames('step-content-container', classes.stepContentContainer)}>
              {StepList &&
                <div className={classNames('step-list-container', classes.stepListContainer, classes[`stepListContainer-${displayMode}`])}>
                  <StepList />
                </div>
              }
              {LoadingShimmer && <LoadingShimmer />}
              <StepContainer />
            </div>
          </div>
          {Footer &&
            <div className={classNames('footer-container', classes.footerContainer)}>
              <Footer />
            </div>
          }
        </div>
      </Blocker>
    </div>
  );
};

PreviewFlowTemplate.propTypes = {
  items: PropTypes.shape({
    Blocker: PropTypes.func,
    LoadingShimmer: PropTypes.func,
    StepList: PropTypes.func,
    StepContainer: PropTypes.func.isRequired,
    Footer: PropTypes.func,
  }).isRequired,
};
